export default function Pagination({ page, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-center gap-2 mt-6">
      <button
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1}
        className="px-3 py-1 rounded bg-royal-800 text-royal-200 hover:bg-royal-700 disabled:opacity-40 disabled:cursor-not-allowed"
      >
        &larr; Prev
      </button>

      <span className="px-4 py-1 text-royal-300 text-sm">
        Page {page} of {totalPages}
      </span>

      <button
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages}
        className="px-3 py-1 rounded bg-royal-800 text-royal-200 hover:bg-royal-700 disabled:opacity-40 disabled:cursor-not-allowed"
      >
        Next &rarr;
      </button>
    </div>
  );
}
